import {ARCHIMATE_CONNECTION, ARCHIMATE_NODE} from '../../metamodel/Concept';
import {isAny, NOTE, OR_JUNCTION, AND_JUNCTION} from '../../util/ModelUtil';

function getLabelAttr(element) {
	if (isAny(element, [ARCHIMATE_NODE, ARCHIMATE_CONNECTION])) {
		switch (element.type) {
			case NOTE:
				return 'text';
			default:
				return 'name';
		}
	}
}

export function getLabel(element) {
	const attr = getLabelAttr(element.businessObject);

	if (attr) {
		return element[attr] || '';
	}
}

export function setLabel(element, text) {
	if (isAny(element.businessObject, [ARCHIMATE_NODE])) {
		if (element.businessObject.type === NOTE) {
			element.text = text;
			element.businessObject.label = text;
		} else if ([OR_JUNCTION, AND_JUNCTION].includes(element.type)) {
			element.text = text;
			element.businessObject.label = text;
			element.businessObject.elementRef.name = text;
		} else {
			element.name = text;
			element.businessObject.elementRef.name = text;
		}
	}

	if (isAny(element.businessObject, [ARCHIMATE_CONNECTION])) {
		element.name = text;
		element.businessObject.name = text;
		if (element.businessObject.relationshipRef) {
			element.businessObject.relationshipRef.name = text;
		}
	}

	return element;
}
